import React from "react";
import './LoadingWall.css';
import Constants from "utilities/js/Constants";

const loadingIcon = Constants.ICON_LOADING;

class LoadingWall extends React.Component {
    constructor(props){
        super(props);
        this.state = {
        };
    }

    render(){

        let classes = 'loading-wall';
        if(!this.props.isLoading){
            classes += ' hide';
        }
        return (
            <div className={classes}>
                <img className="loading-icon" alt="loading-icon" src={loadingIcon}/>
            </div>
        );
    }

}

export default LoadingWall;